module.exports = __webpack_public_path__ + "img/geofisica_4-3_2048.829c6bd9.webp";